import { render, staticRenderFns } from "./m-restricted-button.vue?vue&type=template&id=7eb82270&scoped=true&"
import script from "./m-restricted-button.vue?vue&type=script&lang=js&"
export * from "./m-restricted-button.vue?vue&type=script&lang=js&"
import style0 from "./m-restricted-button.vue?vue&type=style&index=0&id=7eb82270&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb82270",
  null
  
)

export default component.exports